import { useEffect } from 'react'

function useKeyboard(handler, keyCode) {
  useEffect(() => {
    function handlePressKeys(e) {
      const key = e.which || e.keyCode
      if (key === keyCode) {
        handler()
        e.preventDefault()
      }
    }

    document.addEventListener('keydown', handlePressKeys)

    return () => document.removeEventListener('keydown', handlePressKeys)
  })
}

export default useKeyboard
